import { render, staticRenderFns } from "./MatchProfileStep.vue?vue&type=template&id=239551a2"
import script from "./MatchProfileStep.vue?vue&type=script&lang=js"
export * from "./MatchProfileStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports